import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es";

dayjs.extend(customParseFormat);
dayjs.locale("es");

export const FORMAT_DATE_WITH_HOUR = "D [de] MMMM [de] YYYY, H:mm [h]";
export const FORMAT_DATE_WITH_MONTH_NAME = "D-MMM-YYYY";

export const formatDate = (
  date: string,
  format: string,
  isUnixTimestampInSeconds?: boolean,
) => {
  if (isUnixTimestampInSeconds) {
    const numericDate = parseFloat(date);
    if (!isNaN(numericDate)) {
      // Convert Unix timestamp from seconds to milliseconds
      const buildDate = dayjs(numericDate * 1000).locale("es");
      return buildDate.format(format);
    }
  }
  // Try parsing with DD/MM/YYYY format first (common format in Spanish locales)
  let buildDate = dayjs(date, "DD/MM/YYYY", true).locale("es");

  // If that fails, try default parsing
  if (!buildDate.isValid()) {
    buildDate = dayjs(date).locale("es");
  }

  // If still invalid, return empty string or handle error
  if (!buildDate.isValid()) {
    return "";
  }

  return buildDate.format(format);
};
